import { supabase } from '@/lib/supabase/client';
import type { Database } from '@/lib/supabase/types';

type ContactSubmissionRow = Database['public']['Tables']['contact_submissions']['Row'];

export type ContactSubmission = ContactSubmissionRow;

export type ContactFormInput = {
  name: string;
  email: string;
  subject: string;
  message: string;
};

export async function submitContactForm(input: ContactFormInput): Promise<void> {
  await supabase
    .from('contact_submissions')
    .insert(input)
    .throwOnError();
}

export async function listContactSubmissions(): Promise<ContactSubmission[]> {
  const { data } = await supabase
    .from('contact_submissions')
    .select('id, name, email, subject, message, status, created_at')
    .order('created_at', { ascending: false })
    .throwOnError();
  return data ?? [];
}

export async function markContactSubmissionRead(id: string): Promise<void> {
  await supabase
    .from('contact_submissions')
    .update({ status: 'read' })
    .eq('id', id)
    .throwOnError();
}
